import React, { useState, useEffect } from "react";
import { object, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import Headline from "../../atoms/Headline";
import SelectDropdown from "../../atoms/SelectDropdown";
import Icon from "../../icons";
import { TOPICS_FILTER, TOPICS_FILTER_PARENT } from "../../../constants";
import { staticTexts } from "../../utils/Translate";

import "./tagStorySearch.m.css";

const filterChild = id => TOPICS_FILTER.filter(item => item["parent-external-id"] === id);
const filterParent = slug => TOPICS_FILTER_PARENT.find(item => item.slug === slug);
const filterChildBasedOnSlug = slug => TOPICS_FILTER.find(item => item.slug === slug);

const findItem = id => TOPICS_FILTER.find(item => item["external-id"] === id);

function GenerateMetaData(name, id, parentId = null, slug = "") {
  this.name = name;
  this["external-id"] = id;
  this["parent-external-id"] = parentId;
  this.slug = slug;
}

const TagStorySearch = ({
  className = "",
  publisherAttributes,
  localNewsDivisionSlug,
  localNewsDistrictSlug,
  localNewsUpoSlug
}) => {
  const defaultList = [
    new GenerateMetaData(staticTexts(publisherAttributes.lang).section, 0),
    new GenerateMetaData(staticTexts(publisherAttributes.lang).district, 0),
    new GenerateMetaData(staticTexts(publisherAttributes.lang).upazila, 0)
  ];

  const [selectParent, setSelectParent] = useState(null);
  const [selectChild, setSelectChild] = useState(null);
  const [selectSubChild, setSelectSubChild] = useState(null);
  const [childList, setChildList] = useState([]);
  const [subChildList, setSubChildList] = useState([]);
  const [divisionSlug, setDivisionSlug] = useState(null);
  const [districtSlug, setDistrictSlug] = useState(null);
  const [upoSlug, setUpoSlug] = useState(null);

  const onChangeFunc1 = e => {
    setSelectParent(e.target.value);
    setSelectChild(null);
    setSelectSubChild(null);
    setChildList(filterChild(e.target.value));
    const item = findItem(e.target.value);
    setDivisionSlug(item.slug);
    setDistrictSlug(0);
    setUpoSlug(0);
  };

  const onChangeFunc2 = e => {
    setSelectChild(e.target.value);
    setSelectSubChild(null);
    setSubChildList(filterChild(e.target.value));
    const item = findItem(e.target.value);
    setDistrictSlug(item.slug);
    setUpoSlug(0);
  };

  const onChangeFunc3 = e => {
    setSelectSubChild(e.target.value);
    const item = findItem(e.target.value);
    setUpoSlug(item.slug);
  };

  const generateSlug = () => {
    if (districtSlug && divisionSlug && upoSlug) {
      return `tags=${upoSlug}&div=${divisionSlug}&dis=${districtSlug}&upo=${upoSlug}`;
    } else if (divisionSlug && districtSlug) {
      return `tags=${districtSlug}&div=${divisionSlug}&dis=${districtSlug}`;
    } else if (divisionSlug) {
      return `tags=${divisionSlug}&div=${divisionSlug}`;
    } else return "";
  };

  useEffect(() => {
    const setParent = () => {
      const currentParent = filterParent(localNewsDivisionSlug);
      setSelectParent(currentParent["external-id"]);
      setChildList(filterChild(currentParent["external-id"]));
      const item = findItem(currentParent["external-id"]);
      setDivisionSlug(item.slug);
    };

    const setChild = () => {
      const currentChild = filterChildBasedOnSlug(localNewsDistrictSlug);
      setSelectChild(currentChild["external-id"]);
      setSubChildList(filterChild(currentChild["external-id"]));
      const item = findItem(currentChild["external-id"]);
      setDistrictSlug(item.slug);
    };

    const setSubChild = () => {
      const currentSubChild = filterChildBasedOnSlug(localNewsUpoSlug);
      setSelectSubChild(currentSubChild["external-id"]);
      const item = findItem(currentSubChild["external-id"]);
      setUpoSlug(item.slug);
    };

    if (localNewsUpoSlug && localNewsDistrictSlug && localNewsDivisionSlug) {
      setParent();
      setChild();
      setSubChild();
    } else if (localNewsDistrictSlug && localNewsDivisionSlug) {
      setParent();
      setChild();
      const currentChild = filterChildBasedOnSlug(localNewsDistrictSlug);
      setSelectChild(currentChild["external-id"]);
      setSubChildList(filterChild(currentChild["external-id"]));
    } else if (localNewsDivisionSlug) {
      setParent();
    }
  }, []);

  return (
    <div styleName="base" className={className}>
      {!localNewsDivisionSlug && (
        <Headline text={staticTexts(publisherAttributes.lang).localNews} headlineType={12} className="headline-title" />
      )}
      <SelectDropdown
        list={TOPICS_FILTER_PARENT}
        onChange={onChangeFunc1}
        className="dropdown-list"
        defaultItem={defaultList[0]}
        selected={selectParent}
        selectClassName={selectParent ? "active-dropdown" : ""}
      />
      <SelectDropdown
        list={childList}
        onChange={onChangeFunc2}
        className="dropdown-list"
        defaultItem={defaultList[1]}
        selected={selectChild}
        selectClassName={selectChild ? "active-dropdown" : ""}
      />
      <SelectDropdown
        list={subChildList}
        onChange={onChangeFunc3}
        className="dropdown-list"
        defaultItem={defaultList[2]}
        selected={selectSubChild}
        selectClassName={selectSubChild ? "active-dropdown" : ""}
      />
      <button
        styleName="tag-search-btn"
        onClick={() => (window.location.href = "/bangladesh/local-news/?" + generateSlug())}
        disabled={!generateSlug()}
      >
        <span styleName="search-icon">
          <Icon type="search" className="search-icon" />
        </span>
        {staticTexts(publisherAttributes.lang).search}
      </button>
    </div>
  );
};

TagStorySearch.propTypes = {
  className: string,
  story: object,
  publisherAttributes: object,
  localNewsTagSlug: string,
  localNewsDivisionSlug: string,
  localNewsDistrictSlug: string,
  localNewsUpoSlug: string
};

const mapStateToProps = state => {
  return {
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {})
  };
};

export default connect(mapStateToProps, null)(TagStorySearch);
